"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Schema for Module Progress, associated with a moduleId and learnerId
 * @param {ObjectId} objectIdType ObjectId type from mongoose package
 * @returns Array with Collection name and defined Schema
 */
var ModuleProgress = function ModuleProgress(objectIdType) {
  if (!objectIdType) {
    throw new Error('objectIdType must be provided');
  }
  return ['ModuleProgress', {
    _moduleId: {
      type: objectIdType,
      ref: 'Module'
    },
    moduleId: {
      type: objectIdType,
      ref: 'Module',
      required: true
    },
    learnerId: {
      type: objectIdType,
      ref: 'Learner',
      required: true
    },
    started: {
      type: Date,
      required: true
    },
    completed: Date,
    hideExercises: {
      type: Boolean
    },
    slideProgresses: [{
      type: objectIdType,
      ref: 'SlideProgress'
    }]
  }];
};
var _default = ModuleProgress;
exports["default"] = _default;